// API Configuration
export const API_CONFIG = {
  BASE_URL: (typeof window !== 'undefined' && window.location.hostname === 'guideme.elevate.com.es') 
    ? '' 
    : (import.meta.env.VITE_API_URL || 'http://localhost:3001'),
  ENDPOINTS: {
    AUTH: {
      SIGNIN: '/api/auth/login',
      SIGNUP: '/api/signup',
      REFRESH: '/api/refresh',
    },
    USERS: '/api/users',
    SERVICIOS: '/api/servicios',
    CLIENTES: '/api/clientes',
    FACTURAS: '/api/facturas',
    TARIFAS: '/api/tarifas',
    NOTIFICATIONS: '/api/notifications',
    DASHBOARD: '/api/dashboard',
    CALENDAR: '/api/calendar',
    FILES: '/api/files',
    SETTINGS: '/api/settings',
    CONFIGURACION: {
      OPERADORES: '/api/operadores',
      ORIGENES: '/api/origenes',
      IDIOMAS: '/api/idiomas',
      TIPOS_VISITA: '/api/tipos-visita',
      TIPOS_ENTRADA: '/api/tipos-entrada',
      TOUR_LEADERS: '/api/tour-leaders',
    }
  }
};

// Helper function to build full URL
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function for fetch with default headers
export const apiRequest = async (
  endpoint: string, 
  options: RequestInit = {},
  token?: string
): Promise<Response> => {
  const url = buildApiUrl(endpoint);
  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  return fetch(url, config);
};